import { Tabs } from '@/components/common/tabs';

import { ALL_CATEGORIES } from '../constants';
import type { DeviceCategory } from '../types';

import styles from './device-category-tabs.module.scss';

export type DeviceCategoryTabsProps = {
  /** Selected category id, or `null` for "All". */
  value: string | null;
  categories: DeviceCategory[];
  onChange: (categoryId: string | null) => void;
};

/**
 * The quick-filter tabs above the grid (US-112439 §3): "All" plus the grower's own categories
 * from `GET /devices/tracking/meta/categories`, single-select.
 *
 * The AC and Figma both show a fixed **All / Diesel / Electric / Sensors** strip, but the backend
 * carries no diesel/electric/sensor classification — `deviceType` on a list row is a free-form
 * category *name* that varies per account ("Moisture Sensors", "Flow Controllers", …). So the
 * strip has to be data-driven, and it scrolls rather than distributing a fixed set evenly.
 * Tracking Mobile reached the same conclusion; raised for BA/Design.
 *
 * These tabs carry no panes — they are a filter, so only the nav renders.
 */
export function DeviceCategoryTabs({ value, categories, onChange }: DeviceCategoryTabsProps) {
  const items = [
    { key: ALL_CATEGORIES, label: 'All' },
    ...categories.map((category) => ({ key: category.id, label: category.name })),
  ];

  return (
    <Tabs
      variant="pill"
      className={styles.tabs}
      activeKey={value ?? ALL_CATEGORIES}
      onChange={(key) => onChange(key === ALL_CATEGORIES ? null : key)}
      items={items}
    />
  );
}
